import React from 'react'

const SettingHandleText = ({ className }) => (
  <svg
    width="24px"
    height="48px"
    viewBox="0 0 24 48"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <defs />
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g className={className} transform="translate(-104.000000, -37.000000)" fill="#FFFFFF">
        <path d="M104.508399,52.6678154 L117.924555,37.6479458 C118.660386,36.8241573 119.924707,36.7528531 120.748495,37.4886834 C121.021783,37.7327918 121.222754,38.0472897 121.329468,38.3978428 L127.903753,59.9942636 C128.106865,60.6614826 127.947724,61.386322 127.483787,61.9070884 L107.493346,84.3462155 C106.758595,85.1709675 105.494369,85.2439282 104.669617,84.5091779 C104.243638,84.1296841 104,83.5863355 104,83.0158324 L104,54.0001541 C104,53.508659 104.18098,53.0343727 104.508399,52.6678154 Z" id="Rectangle-4" />
      </g>
    </g>
  </svg>
)

export default SettingHandleText



// WEBPACK FOOTER //
// ./src/components/assets/SettingHandleText.js